import React from 'react'
import FullScreenAsset from './FullScreenAsset'
import { useParams } from 'react-router'
import { useFetchWidenAsset } from '../../hooks/useFetchWidenAsset'
import { useLoadingIds } from '../../hooks/useLoadingIds'
import { CanAccess } from '../Elements/Access'
import EmptyLearningCenter from './EmptyLearningCenter'
import { useMountEffect } from '../../hooks/useMountEffect'

const FullScreenContainer: React.FC = () => {
  const { widenAssetKey } = useParams<{
    widenAssetKey: string
    academicYear: string
  }>()

  const { LearningCenter } = useLoadingIds()
  const parsedAssetKey = parseInt(`${widenAssetKey}`)
  const { contentAsset, isLoading, fetchAsset, errorFetchingContent } =
    useFetchWidenAsset({
      assetKey: parsedAssetKey,
      loadingId: LearningCenter.fetchContentDetail,
    })

  const { filetype, embedUrl } = contentAsset ?? {}

  useMountEffect(() => {
    fetchAsset()
  })

  if (errorFetchingContent || !contentAsset) {
    return <EmptyLearningCenter isLoading={isLoading} />
  }

  return (
    <CanAccess I="learningCenter" on="Feature">
      <FullScreenAsset embedUrl={embedUrl} fileType={filetype} />
    </CanAccess>
  )
}

export default FullScreenContainer
